"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _Popup = _interopRequireDefault(require("../Popup"));
var _excluded = ["trigger", "render", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Ref = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Ref, _React$PureComponent);
  var _super = _createSuper(Ref);
  function Ref() {
    _classCallCheck(this, Ref);
    return _super.apply(this, arguments);
  }
  _createClass(Ref, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var innerRef = this.props.innerRef;
      if (innerRef) innerRef((0, _reactDom.findDOMNode)(this));
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react.default.Children.only(children);
    }
  }]);
  return Ref;
}(_react.default.PureComponent);
var TriggeredPopup = /*#__PURE__*/function (_PureComponent) {
  _inherits(TriggeredPopup, _PureComponent);
  var _super2 = _createSuper(TriggeredPopup);
  function TriggeredPopup() {
    var _this;
    _classCallCheck(this, TriggeredPopup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "TriggerEl", void 0);
    _defineProperty(_assertThisInitialized(_this), "state", {
      active: _this.props.active || false,
      triggeredPopup: {
        width: 0
      },
      pageY: 0
    });
    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      _this.closePopup();
      _this.props.onClose();
    });
    _defineProperty(_assertThisInitialized(_this), "onOpen", function () {
      var _this$props$onOpen, _this$props;
      (_this$props$onOpen = (_this$props = _this.props).onOpen) === null || _this$props$onOpen === void 0 ? void 0 : _this$props$onOpen.call(_this$props);
    });
    _defineProperty(_assertThisInitialized(_this), "setTriggerRef", function (r) {
      _this.TriggerEl = r;
    });
    _defineProperty(_assertThisInitialized(_this), "togglePopup", function (e) {
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }
      if (_this.props.disabled) return;
      _this.setState({
        active: !_this.state.active,
        pageY: e.pageY
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closePopup", function () {
      _this.setState({
        active: false
      }, function () {
        if (_this.props.trigger) {
          var _this$TriggerEl;
          (_this$TriggerEl = _this.TriggerEl) === null || _this$TriggerEl === void 0 ? void 0 : _this$TriggerEl.focus();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "isAutoPositioningFromTop", function () {
      var autoPositioningOffset = _this.props.autoPositioningOffset;
      //Is click more than half way down the page + offset
      return _this.state.pageY <= document.body.clientHeight / 2 + (autoPositioningOffset || 0);
    });
    _defineProperty(_assertThisInitialized(_this), "getTriggeredPopup", function (popup) {
      if (!popup) return;
      _this.setState({
        triggeredPopup: popup === null || popup === void 0 ? void 0 : popup.getBoundingClientRect()
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getTriggerNode", function () {
      return _this.TriggerEl;
    });
    return _this;
  }
  _createClass(TriggeredPopup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var active = this.props.active;
      if (nextProps.active !== active) {
        this.setState({
          active: !!nextProps.active
        });
      }
    }
  }, {
    key: "renderTrigger",
    value: function renderTrigger() {
      var triggerProps = {
        onClick: this.togglePopup
      };
      return /*#__PURE__*/_react.default.cloneElement(this.props.trigger, triggerProps);
    }
  }, {
    key: "isFromTop",
    value: function isFromTop() {
      var _this$props2 = this.props,
        fromBottom = _this$props2.fromBottom,
        autoPositioning = _this$props2.autoPositioning;
      //If autoPositioned calculate if to position from top
      if (autoPositioning && !this.isAutoPositioningFromTop()) return false;
      //If not autoPositioned then fromBottom needs to be specified to not show from top
      if (!autoPositioning && fromBottom) return false;
      return true;
    }
  }, {
    key: "getTop",
    value: function getTop() {
      if (this.props.center || !this.isFromTop() || !this.TriggerEl) return;
      var triggerBounding = this.TriggerEl.getBoundingClientRect();
      return triggerBounding.top + triggerBounding.height;
    }
  }, {
    key: "getBottom",
    value: function getBottom() {
      if (this.props.center || this.isFromTop() || !this.TriggerEl) return;
      var triggerBounding = this.TriggerEl.getBoundingClientRect();
      return document.body.offsetHeight - triggerBounding.top;
    }
  }, {
    key: "getLeft",
    value: function getLeft() {
      var _this$props3 = this.props,
        center = _this$props3.center,
        fromRight = _this$props3.fromRight,
        fromCenter = _this$props3.fromCenter;
      if (fromRight || center || !this.TriggerEl) return;
      var triggerBounding = this.TriggerEl.getBoundingClientRect();
      if (fromCenter) return triggerBounding.left + triggerBounding.width / 2 - this.state.triggeredPopup.width / 2;
      return triggerBounding.left;
    }
  }, {
    key: "getRight",
    value: function getRight() {
      var _this$props4 = this.props,
        center = _this$props4.center,
        fromRight = _this$props4.fromRight,
        fromCenter = _this$props4.fromCenter;
      if (!fromRight || center || fromCenter || !this.TriggerEl) return;
      var triggerBounding = this.TriggerEl.getBoundingClientRect();
      return document.body.offsetWidth - triggerBounding.right;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        trigger = _this$props5.trigger,
        render = _this$props5.render,
        children = _this$props5.children,
        others = _objectWithoutProperties(_this$props5, _excluded);
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, trigger ? /*#__PURE__*/_react.default.createElement(Ref, {
        innerRef: this.setTriggerRef,
        key: "R"
      }, this.renderTrigger()) : null, this.state.active ? /*#__PURE__*/_react.default.createElement(_Popup.default, _extends({}, others, {
        getTriggeredPopup: this.getTriggeredPopup,
        getTriggerNode: this.getTriggerNode,
        onClose: this.onClose,
        onOpen: this.onOpen,
        top: this.getTop(),
        left: this.getLeft(),
        right: this.getRight(),
        bottom: this.getBottom()
      }), render ? render(this.closePopup) : children) : null);
    }
  }]);
  return TriggeredPopup;
}(_react.PureComponent);
exports.default = TriggeredPopup;
_defineProperty(TriggeredPopup, "defaultProps", _objectSpread(_objectSpread({}, _Popup.default.defaultProps), {}, {
  noShadow: true
}));